const team = [
  {
    name: 'Mr. C Blendz 💈',
    role: 'Expert Barber & CEO',
    experience: '15+ years',
    specialty: 'Classic & Modern Cuts',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/18bf1ed5dac529a01213f701f53d208e.jpeg'
  }
];

export default function Team() {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">Meet Your Barber</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Dedicated to providing you with the best grooming experience
          </p>
        </div>

        <div className="flex justify-center">
          <div 
            className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer max-w-md w-full"
          >
            <div className="h-96 overflow-hidden">
              <img 
                src={team[0].image}
                alt={team[0].name}
                className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="p-8">
              <h3 className="text-3xl font-bold text-black mb-2">{team[0].name}</h3>
              <p className="text-amber-500 font-semibold mb-4 text-lg">{team[0].role}</p>
              <div className="space-y-3 text-gray-600">
                <div className="flex items-center">
                  <i className="ri-time-line mr-3 w-6 h-6 flex items-center justify-center text-xl"></i>
                  <span>{team[0].experience} experience</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-star-line mr-3 w-6 h-6 flex items-center justify-center text-xl"></i>
                  <span>{team[0].specialty}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
